import React from 'react';
import {MailTemplateDto} from "../../../../../modules/mail/dto/MailTemplateDto";
import {FormattedMessage, useIntl} from "react-intl";
import {Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";

import {useConfirm} from "material-ui-confirm";

export type SearchResultProps = {
    searchResult: Array<MailTemplateDto>;
    onClickDelete: (record: MailTemplateDto) => void;
    onClickModify: (record: MailTemplateDto) => void;
};

const SearchResult: React.FC<SearchResultProps> = (props) => {
    const intl = useIntl();

    const confirm = useConfirm();

    const handleClickDetail = (record: MailTemplateDto) => {
        props.onClickModify(record);
    };

    const handleClickDelete = (record: MailTemplateDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(() => {
                console.log('ok');
                props.onClickDelete(record);
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell><FormattedMessage id={'MAIL_TEMPLATE_CODE'}/></TableCell>
                    <TableCell><FormattedMessage id={'MAIL_TEMPLATE_NAME'}/></TableCell>
                    <TableCell><FormattedMessage id={'COMMON_ACTION'}/></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.searchResult.map((item, index) => (
                    <TableRow key={index}>
                        <TableCell>
                            {item.code}
                        </TableCell>
                        <TableCell>
                            {item.name}
                        </TableCell>
                        <TableCell>
                            <Button size="small" onClick={() => handleClickDetail(item)}><FormattedMessage
                                id={'COMMON_MODIFY'}/></Button>
                            <Button size="small" onClick={() => handleClickDelete(item)}><FormattedMessage
                                id={'COMMON_DELETE'}/></Button>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default SearchResult;
